import styled from 'styled-components/macro';
import { useMyContext } from '../../../providers/Context';
import MessengerPane from '../MessengerPane';
import Chat from '../MessengerPane/Chat';
import MastermindFirstVisit from '../MessengerPane/MastermindFirstVisit';
import MessengerThreadsPane from './MessengerThreadsPane';

const Main = styled.div`
  width: 441px;
  min-height: 600px;
  background-color: #ffffff;
  box-shadow: 0px 60px 70px -30px #888888;
  border-radius: 0px 0px 20px 20px;
`;

function HomebaseBottom() {
  const { messengerState, mastermindState } = useMyContext();

  return (
    <Main>
      {messengerState.display === "operations" ? 
        <MessengerPane />
        : 
        messengerState.display === "mastermind"
          ? < Chat roomID={messengerState.id} />
          : mastermindState.firstVisit
            ? <MastermindFirstVisit />
            : <MessengerThreadsPane />}
    </Main>
  );
}

export default HomebaseBottom;
